import * as React from 'react';
import * as propTypes from 'prop-types';
const sassStyles = require('../ViewTemplates.scss');
import * as _ from 'lodash';

export enum MONSTER_TYPES {
  ACTIVE = 'monsterActive',
  END = 'monsterEnd',
  SCHEDULE = 'monsterSchedule',
  DRAFT = 'drafts',
}

const EmptyState: React.FunctionComponent<{
  src?: string;
  headline: React.ReactNode;
  paragraphs: React.ReactNode[];
  style?: object;
  imageHeight?: number | string;
}> = ({src, headline, paragraphs, style, imageHeight}) => {
  return (
    <div style={{textAlign: 'center', padding: '0px 20px 40px', overflow: 'auto', ...style}}>
      {src ? (
        <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'center', height: 350}}>
          <img
            id="cla-emptystate-monster"
            style={src ? {height: imageHeight || 300, paddingBottom: 10} : undefined}
            src={src ? require('../images/' + src + '.svg') : undefined}
          />
        </div>
      ) : (
        undefined
      )}
      <div id="cla-emptystate-title" className={sassStyles.headLine}>
        {headline}
      </div>
      {_.map(paragraphs, (value, key) => (
        <div id="cla-emptystate-txt" key={key}>
          {value}
        </div>
      ))}
    </div>
  );
};

EmptyState.propTypes = {
  src: propTypes.string,
  headline: propTypes.string.isRequired,
  paragraphs: propTypes.array,
  style: propTypes.object,
  imageHeight: propTypes.number,
};

export default EmptyState;
